import fetchDato from './fetchDato';
import groupBy from './groupBy';
import formatDate from './formateDate';

let body = (id) => `query MyQuery {
    work(filter: {id: {eq: "`+ id +`"}}) {
        title
        images {
            url
        }
        materials{
            name
            description
        }
        survey {
            datetime
            location {
            coordinates {
                latitude
                longitude
            }
            name
            }
            datetime
            subAtomicDate
        }
        workType {
            name
        }
        dimensions {
            unit
            name
            magnitude
        }
    }
}   
`;

const transformWork = r => {
    let $work = { 
    'date': formatDate(r.survey.datetime),
    'subAtomicDate': r.survey.subAtomicDate,
    'locationName' : r.survey.location.name,
    'latitude' : r.survey.location.coordinates.latitude,
    'longitude' : r.survey.location.coordinates.longitude,
    'mapUrl' : (retina=false) => "https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/static/pin-s+555555(" 
        + r.survey.location.coordinates.longitude
        + ","
        + r.survey.location.coordinates.latitude
        + ")/"
        + r.survey.location.coordinates.longitude
        + ","
        + r.survey.location.coordinates.latitude
        + ",6,0/200x200"+ (retina ? "@2x" : "") +"?access_token=pk.eyJ1IjoiY3JhaWctY2hhbWJlcmxhaW4iLCJhIjoiY2ttbTByYmx3MWdiZzJvazV0Zm55ZHBpciJ9.pmN8DDzUEXNr8JH1gXN7Cg",
    'materials' : r.materials,
    'title' : r.title,
    'images' : r.images.map(image => image.url),
    'dimensions' : Array.from(groupBy(r.dimensions, x => x.name), ([name, value]) => ({ name, value }))
    }
    return $work
}

export async function getWork(id) {
    if(!id){ throw 'Invalid id'}
    return await fetchDato(body(id)).then( r => transformWork(r.work) );
};

